module.exports = __webpack_public_path__ + "img/symbol_13_x10.1f4eac6b.png";